import styled from "@emotion/styled";
import "react-slideshow-image/dist/styles.css";

export const CharityNotice = styled.div`
  border-radius: 10px;
  margin-top: 15px;
  font-size: 10pt;
  line-height: 1.5;
`

export const CharityDonation = () => (
  <CharityNotice>When you purchase this artwork, 10% of the sale price will be donated to wildlife conservation charity.</CharityNotice>
);